import { useContext, createContext } from "react";

export const AddInsInit = {
  isEditMode: true,
  setEditMode(val) {
    this.isEditMode = val;
  },
};

export const AddInsContext = createContext(AddInsInit);

export const useAddInsContext = () => useContext(AddInsContext);
